import { render } from "./about-app-tab.vue?vue&type=template&id=d283d42a&ts=true"
import script from "./about-app-tab.vue?vue&type=script&lang=ts"
export * from "./about-app-tab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__